

// OPEN FILTER
let openFilter = document.querySelectorAll('[data-open-filter]')
let filterContainer = document.querySelector('.collection-filter')

openFilter.forEach(button => {
    button.addEventListener('click',function(){
        filterContainer.classList.toggle('active')
        document.querySelector('body').classList.toggle('noScroll')
    })
})


// COLLECTION SORT
Shopify.queryParams = {};
  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  let collectionSortOption =  document.querySelector('#collection-sort-by')
  if(collectionSortOption)
  collectionSortOption.addEventListener('change', function(e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });


const collectionItems = document.querySelector('.collection-items')

function collectionLoading() {
  collectionItems.classList.add('loading')
}

// FORM SUBMIT
const filterForm = document.getElementById('filter-form');
const filterButton = document.getElementById('filter__button')

filterButton.addEventListener('click', ()=> {
  collectionLoading()
  filterForm.submit();
})

let collectionBanner = document.querySelector('#collection-header__banner')

const swiperCollectionBanner = new Swiper("#collection-header__banner", {
  slidesPerView: 2.5,
  spaceBetween: 5,
  //loop:true,

  on: {
    init: function () {
      if(this.params.slidesPerView > this.slides.length)
        collectionBanner.classList.add('collection-header__banner--center');
    },
    resize: function () {

      if(this.params.slidesPerView > this.slides.length)
        collectionBanner.classList.add('collection-header__banner--center');
      else 
        collectionBanner.classList.remove('collection-header__banner--center');
    },
  },

  breakpoints: {
    "640": {
      slidesPerView:2.5,
    },
    "850": {
      slidesPerView:2.5,
    },
    "1024": {
      slidesPerView:3,
      spaceBetween: 20,
    },
    "1440": {
      slidesPerView:4,
      spaceBetween: 20,
    },
    "1940": {
      slidesPerView:4.5,
      spaceBetween: 20,
    },

    "2560":{
      slidesPerView:5.5,
      spaceBetween: 20,
    },
  }
  

});





/*
// USAGE

let usage1 = document.getElementById('Filter-usage-in')
let usage2 = document.getElementById('Filter-usage-out')
let usage3 = document.getElementById('Filter-usage-in-out')

function changeUsage(){
  if(usage3) {
    if(usage1 && !usage2)
    if(usage1.checked)
      usage3.setAttribute('checked','')
    else
      usage3.removeAttribute('checked')

    if(usage2 && !usage1)
    if(usage2.checked)
      usage3.setAttribute('checked','')
    else
    usage3.removeAttribute('checked')
      
    if(usage1 && usage2)
    if(usage1.checked || usage2.checked)
      usage3.setAttribute('checked','')
    else
      usage3.removeAttribute('checked')
  }
}



let filterDelaySubmit;

filterForm.addEventListener('change', ()=>{
  clearTimeout(filterDelaySubmit);
  //changeUsage();
  collectionLoading()
  

  filterDelaySubmit = setTimeout(()=>{
    filterForm.submit();
  },500)

})


let collectionContainer = document.getElementById('collection-container')
let expandCollection = document.getElementById('expandCollection')
let collectionLimit = expandCollection.dataset.limit;
expandCollection.addEventListener('click', function() {



  for(let i = collectionLimit; i < collection.length ;i++ ) {
    collectionContainer.innerHTML += ` 
    <li class='card'> 
      <a href='/products/${collection[i].handle}' class="product-link">
  
        <img class='lazy'
        alt="${collection[i].sku}" 
        src="${collection[i].featured_image}&width=10"
        data-src="${collection[i].featured_image}&width=500"
        >
      </a>

      <div class='card-product-title'><a href="${collection[i].handle}">${collection[i].title}</a></div>

      <div class='product-color-tags'>

      </div>

      <div class="product-price">
        <span data-product-price='${collection[i].price}'>
          <i>$</i>${collection[i].price}
        </span>
        <small class='product-price-tax'>( Tax)</small>   
      </div>
    </li>
    ` 
    
  }
  collectionLimit+20;
  
  lazyLoadInstance.update()
})
*/



/*
let seeMoreButton  = document.getElementById('see-more')
let collectionContainer = document.getElementById('collection-container')

seeMoreButton.addEventListener('click', function() {

  async function fetchProducts() {
    const response = await fetch('/collections/all/products.json?sort_by=best-selling');
    response.ok;     // => false
    response.status; // => 404
    const text = await response.text();

    return text;
  }




  fetchProducts().then(json => {
     
      let products = JSON.parse(json)
      console.log(products)
      products.products.forEach(product => {
       
        
        // LI 
        let list = document.createElement('li')
        list.setAttribute('class','card')

        //THUMBNAIL

        let thumbnail = document.createElement('a');
        thumbnail.setAttribute('class','product-link')
        thumbnail.setAttribute('href',`/products/${product.handle}`)

        let picture = document.createElement('picture')
        let image = document.createElement('img')
        let source = document.createElement('source')

        if(product.variants[0].featured_image.src)
        image.setAttribute('src',product.variants[0].featured_image.src)
        if(product.variants[0].featured_image.src)
        source.setAttribute('srcset',product.variants[0].featured_image.src)


        picture.appendChild(source)
        picture.appendChild(image)

        thumbnail.appendChild(picture)
        
        //TITLE
        let titleContainer = document.createElement('div')
        titleContainer.setAttribute('class','card-product-title')
       
        let title = document.createElement('a')
        title.setAttribute('href',`/products/${product.handle}`)
        title.textContent = product.title
        titleContainer.appendChild(title)

        //COLOR TAG CONTAINER
        let colorTagContainer = document.createElement('div')
        colorTagContainer.setAttribute('class','product-color-tags')

        //COLOR
        let colorContainer = document.createElement('div')
        colorContainer.setAttribute('class','variant-color-wrap')

        
       
        let variantColor =''
        product.variants.forEach(variant => {
            variantColor.variant.option1
          
          
          let color = document.createElement('span')
          
          color.setAttribute('class','variant-color')
            color.setAttribute('style',`background-color:${[variant.option1]};`)
            if(variant.featured_image)
            color.setAttribute('data-src',variant.featured_image.src)
            colorContainer.appendChild(color)
   
        });
        

        colorTagContainer.appendChild(colorContainer)



        //TAG


        let tagContainer = document.createElement('div')
        tagContainer.setAttribute('class','tag-container')

        product.tags.forEach(tag => {
          let spanTag = document.createElement('span')
          spanTag.textContent = tag
          tagContainer.appendChild(spanTag)
        });
        colorTagContainer.appendChild(tagContainer)

        //PRICE
        
        let priceContainer = document.createElement('div')
        priceContainer.setAttribute('class','product-price')

        let spanPrice = document.createElement('span')
        spanPrice.setAttribute('class','product-pricing')

        let currencySymbol = document.createElement('i')
        currencySymbol.textContent = '¥'

        spanPrice.appendChild(currencySymbol)
        spanPrice.append(product.variants[0].price)

        priceContainer.appendChild(spanPrice)

        let tax = document.createElement('small')
        tax.setAttribute('class','product-price-tax')
        tax.textContent = '(税込)';
        priceContainer.appendChild(tax)

        // CARD
        
        list.appendChild(thumbnail)
        list.appendChild(titleContainer)
        list.appendChild(colorTagContainer)
        list.appendChild(priceContainer)

       
        collectionContainer.appendChild(list)



      });

  });

})



*/